<template>
  <div class="dialog-wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-drawer
      title="批量修改"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="520"
      destroy-on-close
      append-to-body
    >
      <div class="content-wrap">
        <div class="dialog-title">
          <p class="title">修改上课时间</p>
          <p class="total">已选择{{ originArray.length }}课时</p>
        </div>
        <el-form
          class="main-form"
          size="mini"
          :model="form"
          ref="mainForm"
          :rules="rules"
          label-width="110px"
        >
          <div style="display: flex">
            <el-form-item label="上课时间:" prop="start_time">
              <step-time-range-selector
                :originStart.sync="form.start_time"
                :originEnd.sync="form.end_time"
              ></step-time-range-selector>
            </el-form-item>
            <time-step-selector
              :oriStart.sync="form.start_time"
              :oriEnd.sync="form.end_time"
            ></time-step-selector>
          </div>
        </el-form>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="closeDialog">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              保存
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
  </div>
</template>
<script>
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
import conflictDialog from "../log/conflictDialog.vue";
import { lessonTimeConflictCheckApi } from "@/api/classSchedule";
import timeStepSelector from "@/components/timeStepSelector.vue";
import { mutiEditTimeApi } from "@/api/lesson";

export default {
  name: "classDetailLogMutiEditTime",
  components: {
    stepTimeRangeSelector,
    timeStepSelector,
    conflictDialog,
  },
  // @Prop() ori!: any[];
  // @Prop() cid!: number;
  props: ["ori", "cid"],
  data() {
    return {
      originArray: [],
      form: {
        class_id: 0,
        start_time: "",
        end_time: "",
      },
      dialogVisible: false,
      rules: {
        start_time: [
          { required: true, message: "请选择上课时间", trigger: "change" },
        ],
      },
      conflictDialogVisible: false,
      conflictDialogData: {},
    };
  },
  methods: {
    openDialog() {
      this.form = {
        class_id: this.cid,
        start_time: "09:00",
        end_time: "09:45",
      };
      this.dialogVisible = true;
      this.originArray = [...this.ori];
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          const stime = this.form.start_time.slice(0, 5) + ":00";
          const etime = this.form.end_time.slice(0, 5) + ":00";
          if (
            Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))
          ) {
            this.$message({
              type: "warning",
              message: "上课结束时间必须大于开始时间",
            });
            return false;
          }
          this.handleConflictCheck();
        }
      });
    },
    handleConflictCheck() {
      const stime = this.form.start_time.slice(0, 5) + ":00";
      const etime = this.form.end_time.slice(0, 5) + ":00";
      lessonTimeConflictCheckApi({
        class_id: Number(this.cid),
        lesson_ids: [...this.originArray],
        start_time: stime,
        end_time: etime,
      }).then((res) => {
        if (res.error_code === 0) {
          if (res.data.conflict) {
            this.conflictDialogVisible = true;
            this.conflictDialogData = res.data;
          } else {
            this.conflictConfirm();
          }
        }
      });
    },
    conflictConfirm() {
      const stime = this.form.start_time.slice(0, 5) + ":00";
      const etime = this.form.end_time.slice(0, 5) + ":00";
      if (Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))) {
        this.$message({
          type: "warning",
          message: "上课结束时间必须大于开始时间",
        });
        return false;
      }
      const params = {
        lesson_ids: this.originArray,
        class_id: this.cid,
        start_time: stime,
        end_time: etime,
      };
      mutiEditTimeApi(params).then(() => {
        this.$message({
          type: "success",
          message: "编辑成功",
        });
        this.closeDialog();
        this.$emit("change");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-wrap {
  display: inline-block;
}
.content-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-title {
    padding: 20px 0;
    margin: 0 47px;
    border-bottom: 1px dashed #e7e8ea;
    .title {
      font-size: 14px;
      line-height: 18px;
      color: #5c5d5e;
      margin-bottom: 17px;
      font-weight: bold;
    }
    .total {
      font-size: 12px;
      line-height: 16px;
      color: #ffb940;
    }
  }
  .main-form {
    flex: 1;
    padding: 16px 0;
  }
  .footer {
    padding: 20px;
    .btns {
      text-align: right;
      .mwow-button-filled {
        margin-left: 10px;
      }
    }
  }
}
</style>
